<template>
  <div>
    <div class="search_wrap">
      <el-form
        :model="queryParam"
        ref="form"
        label-width="80px"
        :inline="true"
        size="mini"
      >
        <el-form-item label="店铺名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.storeName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.name"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input
            @keyup.enter.native="searchQuery"
            v-model="queryParam.phone"
            placeholder="请输入"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchQuery">查询</el-button>
          <el-button type="default" @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <e-table
      :listLoading="loading"
      :selection="true"
      :tableHeadConfig="columns"
      @pageChange="loadData"
      :paginationData="ipagination"
      :tableLoadData="dataSource"
      @selectLine="onSelectChange"
      :tableRowClassName="tableRowClassName"
    >
    </e-table>
  </div>
</template>

<script>
import eTable from "@/components/table";
import { listMixin } from "@/mixins/listMixin";
import { filterObj } from '@/utils/util';
import { postAction } from "@/api/manage";
export default {
  name: "deviceList",
  components: { eTable },
  mixins: [listMixin],
  created() {},
  mounted() {
    this.dateDefaultShow = new Date();
    this.dateDefaultShow.setMonth(new Date().getMonth() - 1);
  },
  computed: {},
  watch: {},
  data() {
    return {
      url: {
        list: "/busiUser/queryPage",
      },
      queryParam: {},
      expirationTime: '',
      dateDefaultShow: "",
      columns: [
        {
          field: "storeName",
          fixed: "left",
          label: "店铺名",
        },
        {
          field: "name",
          label: "姓名",
        },
        {
          field: "phone",
          label: "手机号",
        },
        {
          field: "totalAmount",
          label: "总余额",
        },
        {
          field: "currentAmount",
          label: "当前余额",
        },
        {
          field: "frozenAmount",
          label: "冻结余额",
        },
        {
          field: "address",
          label: "店铺地址",
        },
      ],
      deviceList: [],
      ipagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  methods: {
    dateChange(date) {
      if (date) {
        this.queryParam.startTime = date[0] + " 00:00:00";
        this.queryParam.endTime = date[1] + " 00:00:00";
      } else {
        this.queryParam.startTime = "";
        this.queryParam.endTime = "";
      }
    },
    resetForm() {
      this.queryParam = {};
      this.expirationTime = "";
      this.searchQuery();
    },
    loadData(arg) {
      if (!this.url.list) {
        this.$message.error('请设置url.list属性!');
        return;
      }
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var params = this.getQueryParams();
      this.loading = true;
        postAction(this.url.list, params).then((res) => {
          if (res.msg) {
            this.$message.warning(res.msg);
            return;
          }
          this.dataSource = res.data.records
          if (res.data.total) {
            this.ipagination.total = res.data.total;
          } else {
            this.ipagination.total = 0;
          }
          this.loading = false;
        });
    },
    getQueryParams() {
      var param = Object.assign(this.queryParam, this.isorter, this.filters);
      param.page = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      param.childFlag = 0;
      param.filter = 0;
      return filterObj(param);
    },
  },
};
</script>

<style scoped lang="less">
.search_wrap {
  margin: 10px 0;
}
.selectBox {
  margin-bottom: 18px;
  display: inline-block;
  margin-right: 10px;
  vertical-align: top;
}
.selectText {
  width: 80px;
  line-height: 28px;
  font-weight: 700;
  cursor: default;
  float: none;
  display: inline-block;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
